export enum FileTypes {
	Video = "VIDEO",
	Image = "IMAGE",
	Text = "TEXT",
	Audio = "AUDIO",
	Spoiler = "SPOILER",
	Unknown = "UNKNOWN",
}
